import React from 'react';
import {Card, CardBody, CardHeader, Col, Collapse, Row} from "reactstrap";
import Lbl from "../../../components/Label/Lbl";
import {Button as SementicBtn, Button, Icon, Label} from "semantic-ui-react";
import {MDBDataTable} from "mdbreact";
import {Empty, Tooltip} from "antd";
import { DatePicker } from 'antd';
import './Style.css';
import moment from "moment";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import axios from "../../../axios/axios_visitortag";
import apiConfig from "../../../axios/axios_api_services";
import * as common from "../../../const/Common/CommonFunc";
import Cookies from 'js-cookie';

const { RangePicker } = DatePicker;

function addMonths(date, months) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + +months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
}

function dateToString(value) {
  let t = new Date(value);
  let date = ('0' + t.getDate()).slice(-2);
  let month = ('0' + (t.getMonth() + 1)).slice(-2);
  let year = t.getFullYear();
  const time = `${year}-${month}-${date}`;
  return time;
}

function getDateRange() {
  let date1 = addMonths(new Date(),-1).toString();
  let dateArrayx = date1.split(" ");
  let datex = dateArrayx[0]+" "+dateArrayx[1]+" "+dateArrayx[2]+" "+dateArrayx[3];
  let sdate = dateToString(datex);
  let date2 = addMonths(new Date(),1).toString();
  let dateArrayy = date2.split(" ");
  let datey = dateArrayy[0]+" "+dateArrayy[1]+" "+dateArrayy[2]+" "+dateArrayy[3];
  let edate = dateToString(datey);
  let dateRange = [sdate, edate];
  return dateRange;
}

class App extends React.Component {
  state = {
    meetingFilterSDate: "",
    meetingFilterEDate: "",
    meetingList: [
      // {
      //   refNo : "3254236748hytr8568525",
      //   isReccurentMeeting : true,
      //   visitors : [
      //     {
      //         firstName : "KK",
      //         lastName : "KK",
      //         identificationValue : "123",
      //         mobile : "XXXXXXXXX",
      //         email : "XXXXXXXXX",
      //         companyName : "XXXXXXXXX",
      //         title : "Mr",
      //     }
      //   ],
      //   meetingSeries : [
      //     {
      //       hostA : 1,
      //       refNo : "3254236748hytr8568525",
      //       floor : {
      //         floorId : 2,
      //         description : "floor description",
      //         floorColour : "Yellow",
      //         level : "level 02",
      //         status : "string",
      //         buildingId: 24
      //       },
      //       building : {
      //         buildingId : 24,
      //
      //         code : "string",
      //         levelCount : 15,
      //         location : "Colombo 06",
      //         name : "park land",
      //         status : "string",
      //         branchId : 45
      //       },
      //       title : "weekly team gathering",
      //       description : "weekly meeting",
      //       visitingPurpose : "Business",
      //       startTime : "2020-07-01 09:00:00",
      //       endTime : "2020-07-29 11:00:00"
      //     }
      //   ]
      // },
      // {
      //   refNo : "3254236748hytr8568525",
      //   isReccurentMeeting : false,
      //   visitors : [
      //     {
      //         firstName : "xx",
      //         lastName : "xx",
      //         identificationValue : "xx",
      //         mobile : "xx",
      //         email : "xx",
      //         companyName : "xx",
      //         title : "Mr",
      //     }
      //   ],
      //   meetingSeries : [
      //     {
      //       hostA : 1,
      //       refNo : "3254236748hytr8568525",
      //       floor : {
      //         floorId : 2,
      //         description : "floor description",
      //         floorColour : "Yellow",
      //         level : "level 02",
      //         status : "string",
      //         buildingId: 24
      //       },
      //       building : {
      //         buildingId : 24,
      //
      //         code : "string",
      //         levelCount : 15,
      //         location : "Colombo 06",
      //         name : "park land",
      //         status : "string",
      //         branchId : 45
      //       },
      //       title : "weekly team gathering",
      //       description : "weekly meeting",
      //       visitingPurpose : "Business",
      //       startTime : "2020-07-01 09:00:00",
      //       endTime : "2020-07-29 11:00:00"
      //     }
      //   ]
      // }
    ]
  }

  componentDidMount() {
    let date = getDateRange();
    let d1 = new Date(date[0]+" 00:00:00");
    let d2 = new Date(date[1]+" 23:59:59");
    this.setState({
      meetingFilterSDate: date[0]+" 00:00:00",
      meetingFilterEDate: date[1]+" 23:59:59",
    });
    this.onHandleFilterMeetings(date[0]+" 00:00:00", date[1]+" 23:59:59");
  }

  onHandleChangeDateRange = (date, dateString) => {
    if (dateString[0] !== "" || dateString[1] !== "") {
      let start = new Date(dateString[0]);
      let end = new Date(dateString[1]);
      start = (start.toISOString()).split("T")[0];
      end = (end.toISOString()).split("T")[0];
      this.setState({
        meetingFilterSDate: start+" 00:00:00",
        meetingFilterEDate: end+" 23:59:59",
      });

      this.onHandleFilterMeetings(start+" 00:00:00", end+" 23:59:59");
    }
  }

  onHandleFilterMeetings = (meetingFilterSDate, meetingFilterEDate) => {

    // var minutes = 1000 * 60;
    // var hours = minutes * 60;
    // var days = hours * 24;
    // var years = days * 365;
    // var dS = new Date(meetingFilterSDate);
    // var dE = new Date(meetingFilterEDate);
    // var t1= dS.getTime();
    // var t2= dE.getTime();

    var t1 = meetingFilterSDate;
    var t2 = meetingFilterEDate;

    this.props.spinnerHandler(true);
    const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")};
    let corporateId = this.props.usr_obj.corporates[0].corporateId;
    axios.get(apiConfig.HOST_ALL_MEETING({corporateId:corporateId, startDate:t1, endDate:t2}), { headers: headers })
      .then(response => {
        if (response.data.success) {
          let res = response.data.meetings;
          this.setState({meetingList: res});
        } else {
          this.setState({meetingList: []});
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.onHandleFilterMeetings(meetingFilterSDate, meetingFilterEDate)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  }

  onHandleShowMeetingLayer = (obj, index) => {
    let meetingHost = this.props.setMeetingHost(obj);
    if(meetingHost !== null) {
      this.props.history.push("/host/allmeetings/showmeeting");
    }
  }

  render() {

    let meeting_rows = [];
    let meeting_cols = [
      {
        label: 'Title',
        field: 'title',
        sort: 'asc'
      },
      {
        label: 'Start Date',
        field: 'start_date',
        sort: 'asc'
      },
      {
        label: 'Start Time',
        field: 'start_time',
        sort: 'asc'
      },
      {
        label: 'End Time',
        field: 'end_time',
        sort: 'asc'
      },
      {
        label: 'Until',
        field: 'end_date',
        sort: 'asc'
      },
      {
        label: 'Recurring Meeting',
        field: 'recurrence',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }]

    if (this.state.meetingList.length !== 0) {

      this.state.meetingList.map((meeting, index) => {

        let start_date_time = meeting.meetingSeries[0].startTime;
        let end_date_time = meeting.meetingSeries[meeting.meetingSeries.length - 1].endTime;

        let start_date_time_array = start_date_time.split(" ");
        let start_date = start_date_time_array[0];
        let start_time = start_date_time_array[1];

        let end_date_time_array = end_date_time.split(" ");
        let end_date = end_date_time_array[0];
        let end_time = end_date_time_array[1];

        let r_meeting =  meeting.recurrentMeeting?
          <Label as='a'  color='blue'><Icon name='check circle' />Recurring meeting</Label>:
          <Label as='a' color='red'><Icon name='times circle' />Non-recurring meeting</Label>;

        let meeting_row = {
          title:  meeting.meetingSeries[0].title,
          start_date: start_date,
          start_time: start_time,
          end_time: end_time,
          end_date: end_date,
          recurrence: r_meeting,
          action: <div>
                    <SementicBtn circular className="btncircular" icon='eye'
                                 onClick={() => this.onHandleShowMeetingLayer(meeting, index)}
                    />
                  </div>
        }

        meeting_rows.push(meeting_row);

      })
    }
    let table_data = { columns: meeting_cols, rows: meeting_rows };

    let dateRange = null;
    if(this.state.meetingFilterSDate !== "") {
      let meetingFilterSDate = this.state.meetingFilterSDate;
      let meetingFilterEDate = this.state.meetingFilterEDate;
      dateRange = [moment(meetingFilterSDate), moment(meetingFilterEDate)];
    }else{
      dateRange = null;
    }

    return(
      <div>
        {/*<h5 className="topicColor">All Meetings</h5>*/}
        <Row className="main-row-padding">
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            <Card>
              <CardHeader>
                All Meetings
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>
                  <Row>
                    <Col lg ={6} md={6}>
                        <Lbl>Filter Meetings</Lbl>
                        <RangePicker
                          size={"mini"}
                          format="YYYY-MM-DD"
                          value = {dateRange}
                          onChange={this.onHandleChangeDateRange}

                        />
                    </Col>

                  </Row>
                  <Row style={{marginTop: '20px'}}>
                    <Col lg ={12} md={12}>

                      {
                        this.state.meetingList.length !== 0?
                          <MDBDataTable
                            searching={true}
                            displayEntries={true}
                            // paging={false}
                            // entries={0}
                            responsive
                            responsiveSm
                            responsiveMd
                            responsiveLg
                            responsiveXl
                            bordered
                            hover
                            data={table_data}
                          />
                          : <div className={"align-center fully-width"}>
                            <Empty description={"Records not found"} className={"empty-icon"}/>
                          </div>
                      }
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  purpose_options_list: state.reception_SheduleMeetingReducer.visitors_purpose_options_list,
  all_building_list: state.reception_SheduleMeetingReducer.all_building_list,
  all_floor_list: state.reception_SheduleMeetingReducer.all_floor_list,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    callAllBuildings: (data) => dispatch(actionCreator.callAllBuildingsForHost(data)), // Get All Buildings Of Corporate
    setMeetingHost: (data) => dispatch(actionCreator.setMeetingHost(data)),
    removeMeetingHost: () => dispatch(actionCreator.removeMeetingHost()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);

